import controller from './escalation-builder.controller';

const template = require('./escalation-builder.html');

export default {
    controller,
    template,
    bindings: {
        escalationLevels: '<',
        organizationId: '<',
        contactGroups: '<',
        triggerField: '<',
        reminderNotifications: '<',
        resolvedNotifications: '<',
        allProjects: '<',
        matchingProjects: '<',
        readOnly: '<',
        restrictedActions: '<',
        showTemplateOption: '<',
        onLevelsChange: '&',
        onRequestTemplate: '&',
    }
};
